import React, { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAdminEvent, useUpdateEvent } from '../../../hooks/useEvents';
import { useToast } from '../../../hooks/useToast';
import { formatDate } from '../../../utils/formatters';
import EventForm from '../../../components/forms/EventForm';
import Loading from '../../../components/common/Loading';
import ErrorMessage from '../../../components/common/ErrorMessage';

const EventEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: event, isLoading, error, refetch } = useAdminEvent(id);
  const updateEvent = useUpdateEvent();
  const toast = useToast();

  // Os inputs date/datetime-local exigem formato local, não o ISO devolvido pela API.
  const initialData = useMemo(() => {
    if (!event) return null;

    return {
      ...event,
      startsAt: event.allDay
        ? formatDate(event.startsAt, 'yyyy-MM-dd')
        : formatDate(event.startsAt, "yyyy-MM-dd'T'HH:mm"),
      endsAt: event.endsAt ? formatDate(event.endsAt, "yyyy-MM-dd'T'HH:mm") : '',
      description: event.description || '',
      location: event.location || '',
      color: event.color || '#B47330',
    };
  }, [event]);

  const handleSubmit = async (data) => {
    try {
      await updateEvent.mutateAsync({ id, data });
      toast.success('Evento atualizado com sucesso!');
      navigate('/admin/calendario');
    } catch (error) {
      toast.error('Erro ao atualizar evento: ' + error.message);
    }
  };

  if (isLoading) {
    return <Loading text="Carregando evento..." />;
  }

  if (error) {
    return <ErrorMessage message={error.message} onRetry={refetch} />;
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <button
          onClick={() => navigate('/admin/calendario')}
          className="flex items-center text-gray-600 hover:text-gray-900 mb-4"
        >
          <ArrowLeft className="h-5 w-5 mr-2" />
          Voltar para lista
        </button>
        <h1 className="text-2xl font-bold text-gray-900">Editar Evento</h1>
        <p className="text-gray-600 mt-1">Atualize as informações do evento</p>
      </div>

      {/* Form */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <EventForm
          initialData={initialData}
          onSubmit={handleSubmit}
          isLoading={updateEvent.isPending}
        />
      </div>
    </div>
  );
};

export default EventEdit;
